import { render, staticRenderFns } from "./SpeciesFilter.vue?vue&type=template&id=2b5d120a&"
import script from "./SpeciesFilter.vue?vue&type=script&lang=js&"
export * from "./SpeciesFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports